/**
 * @generated SignedSource<<042a7dc8fee0e56f486563e3b65cd10a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoOverlay_viewer$data = {
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentType": "VideoOverlay_viewer";
};
export type VideoOverlay_viewer$key = {
  readonly " $data"?: VideoOverlay_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoOverlay_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoOverlay_viewer",
  "selections": [
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "50b7c0200815377dd994289bdc9876f3";

export default node;
